export const mapBranchesToUI = (data) => {
    const branches = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            branches.push({ label: data[key].attributes.nameEn, value: data[key].id });
        });
    }
    return branches;
};

export const mapAdminsToUi = (data) => {
    const admins = [];
    const keys = Object.keys(data);
    keys.forEach((key) => {
        admins.push({ value: data[key].id, label: data[key].attributes.email });
    });
    return admins;
};
